import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useGenericWorkflowStatus,
  useUserWorkflowList,
} from "../../../../reactQuery/workflows";
import { useMineCards } from "../../../../reactQuery/cards";
import Kanban from "../../components/KanbanBoard/Kanban";
import Loader from "../../../../components/Loader";

const UsersKanban = React.memo(({ users }) => {
  const [searchParams] = useSearchParams();
  const isUnassignedTask = searchParams.get("isUnassigned");
  const boards = searchParams.get("board");

  const {
    isLoading: genericWorkflowStepsLoading,
    genericWorkflowStatus: workflowData,
  } = useGenericWorkflowStatus();
  const { userWorkflows } = useUserWorkflowList();
  const genericWorkflowId = userWorkflows?.data?.data?.responseData?.find(
    (workflow) => workflow.is_generic
  )?.workflow_id;

  const {
    data: mineCards,
    isLoading: isMineCardsLoading,
    refetch,
  } = useMineCards(
    users,
    [],
    [],
    false,
    genericWorkflowId,
    Boolean(isUnassignedTask),
    boards ? boards?.split(",") : []
  );

  useEffect(() => {
    refetch();
  }, [users, refetch]);

  return (
    <>
      {workflowData &&
      !isMineCardsLoading &&
      mineCards?.data.data.responseData ? (
        <Kanban
          cards={mineCards?.data.data.responseData}
          workflowSteps={workflowData.data.data.responseData
            .filter((el) => !el.is_completed)
            .sort((a, b) => a.step_sequence - b.step_sequence)}
          isMyTaskView={true}
        />
      ) : (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
    </>
  );
});

export default UsersKanban;
